<template>
    <div>
    <div class="wave-background">
  <!-- <svg viewBox="0 0 1440 320"><path fill="#00bfff" fill-opacity="1" d="M0,256L30,229.3C60,203,120,149,180,122.7C240,96,300,96,360,122.7C420,149,480,203,540,213.3C600,224,660,192,720,181.3C780,171,840,181,900,186.7C960,192,1020,192,1080,186.7C1140,181,1200,171,1260,165.3C1320,160,1380,160,1410,160L1440,160L1440,320L1410,320C1380,320,1320,320,1260,320C1200,320,1140,320,1080,320C1020,320,960,320,900,320C840,320,780,320,720,320C660,320,600,320,540,320C480,320,420,320,360,320C300,320,240,320,180,320C120,320,60,320,30,320L0,320Z"></path></svg> -->
</div>
<div class="login-container login-card" :style="getBackgroundLayer" >
    <div class="left-section">
        <div class="domain-info">
            <a href="#" class="logo"> 
                <img :src="getLogoInfo" alt="Logo"  :style="getCustomLogoStyles"/>
            </a>
            <div class="landing-content">
                <template v-if="isThisCustomContent">
                      <div class="env-section">
                            <div class="content-wrapper">
                            <h3 class="custom-header" :style="getCustomHeader">{{ envConfig.HEADING }}</h3>
                            <p class="custom-slogan" :style="getCustomSlogan">{{ envConfig.SLOGAN }}</p>
                            <p class="custom-content1" :style="getCustomContent">{{ envConfig.CONTENT1 }}</p>
                            <p class="custom-content2 hidden-sm-and-down" :style="getCustomContent">{{ envConfig.CONTENT2 }}</p>
                            </div>
                        </div>
                </template>
                <template v-else>
                <p class="mb-1 available text-uppercase" style="letter-spacing: 4px; font-size: 14px">
                    Welcome to
                </p>
                <p class="available mb-1 ">
                    <span> Your Digital Transformation Partner </span>
                </p>
               <h1 class="site-title">
  KodeFast
  <span class="flip-text strike-container">
    <span class="front strike-animate">Low</span>
    <span class="back">No</span>
  </span>
  Code Platform
</h1>

                <div class="layout justify-center row wrap"></div>
                <div class="legal mt-3 pb-3 hidden-sm-and-down">
                    <p class="mb-1">
                        Transform your business with powerful workflows, seamless Automation's, and innovative tools—all without the
                        need for any coding! <br /> Let's unlock your potential together!
                    </p>
                </div>
                </template>

            </div>
        </div>
    </div>
    <div class="right-section">
        <router-view />
    </div>
</div>
</div>
</template>

<script>
import DefaultSEOData from "../../config/seo";
import Config  from "../../config/app";
import CustomizationLayer from "@/mixins/CustomizationLayer";
export default {
    name: "PublicLayout",
    mixins:[CustomizationLayer],
    data() {
        return {
            pageData: {
                title: '',
                description: '',
                keywords: '',
                image: '',
                favicon: ''
            },
            defaultConfig:{
                logo:"../../assets/logo.webp",
                background: "../../assets/landing-hero.webp"
            },
            envConfig: Config,

        };
    },
      metaInfo() {
    const meta = { ...DefaultSEOData, ...this.pageData }
    return {
      title: meta.title || 'Default Title',
      meta: [
        // Basic SEO
        { name: 'description', content: meta.description || '' },
        { name: 'keywords', content: meta.keywords || '' },
        { name: 'robots', content: 'index,follow' },

        // OpenGraph (for social sharing)
        { property: 'og:title', content: meta.title || '' },
        { property: 'og:description', content: meta.description || '' },
        { property: 'og:image', content: meta.image || '' },
        { property: 'og:type', content: 'website' },

        // Twitter Cards
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: meta.title || '' },
        { name: 'twitter:description', content: meta.description || '' },
        { name: 'twitter:image', content: meta.image || '' }
      ],
      link: [
        // Favicon and icons
        { rel: 'icon', type: 'image/x-icon', href: meta.favicon || '/favicon.ico' },
        { rel: 'icon', type: 'image/png', href: meta.favicon || '/favicon.png' },
        { rel: 'apple-touch-icon', href: meta.favicon || '/apple-touch-icon.png' }
      ]
    };
  },
    mounted() {
        this.$store.dispatch("auth/reset");
        this.$store.commit("company/resetCompaniesByEmail");
    },
    created() {
        this.$store.commit("errors/setErrors", null, {
            root: true
        });
        setTimeout(() => {
            this.pageData=this.getPageTagsForSEO('MAIN_LAYOUT');
        }, 1000);
    }
};
</script>

<style lang="scss" scoped>
.swal2-icon {
    .swal2-info {
        border-color: #f754a2 !important;
        color: #f754a2 !important;
    }
}

.swal2-styled {
    .swal2-confirm {
        background-color: #f754a2 !important;
    }
}

a {
    text-decoration: none !important;
    color: #196392 !important;
}

a:hover {
    text-decoration: underline !important;
    color: #196392 !important;
}

.forgot-password-link {
    font-size: 14px;
    color: #409eff;
    text-decoration: none;
    font-weight: bold;
}

.forgot-password-link:hover {
    text-decoration: underline;
}
.divider {
    display: flex;
    align-items: center;
    width: 100%;
    text-align: center;
    /* margin: 0 20px; */
}

.line {
    flex: 1;
    border-top: 1px solid #ddd;
}

.divider-text {
    margin: 0 10px;
    color: #aaa;
    font-size: 16px;
    font-weight: bold;
}

.login-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.login-title {
    font-size: 24px;
    margin: 0;
}



.forgot-password-link {
    font-size: 14px;
    color: #409eff;
    text-decoration: none;
}

.forgot-password-link:hover {
    text-decoration: underline;
}

.forgot-login-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    flex-wrap: wrap;
}

.forgot-password-link {
    font-size: 14px;
    color: #409eff;
    text-decoration: none;
    cursor: pointer;
    margin: 4px 0;
}

.login-button {
    padding: 6px 16px;
    font-size: 14px;
    border-radius: 4px;
    min-width: 90px;
}

.center-link {
    text-align: center;
}

.logo {
    img {
        width: 14em;
        padding: 5px;
        margin: 5px;
       //border: 1px solid #0c0c0c42;
        //border-radius: 10px;
        //background: #fff;
        //margin-bottom: 27%;

        @media (max-width: 1024px) {
            width: 14em;
            // margin-bottom: 15%;
        }

        @media (max-width: 480px) {
            width: 10em;
            // margin-bottom: 10%;
        }
    }

&:hover {
  animation: pulse 1s infinite;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}
}

.password-input-wrapper {
    position: relative;
}

.password-toggle {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #409eff;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    user-select: none;
}

.forgot-password-row {
    text-align: right;
    margin-top: -10px;
}

.forgot-password-link {
    color: #409eff;
    text-decoration: underline;
    font-size: 14px;
    cursor: pointer;
}

.login-container {
    display: flex;
    flex-direction: row;
    min-height: 100vh;
    width: 100%;
    /* background-image: url("https://image.bodiscdn.com/parking/landing-hero.png"); */
    // background-image: url("https://static.vecteezy.com/system/resources/previews/009/839/804/non_2x/modern-background-with-wavy-sparkling-liquid-pattern-on-shiny-glossy-surface-vector.jpg");
    background-size: cover;
    background-position: center;
    overflow: hidden;
}

.left-section {
    flex: 1;
    display: flex;

    justify-content: center;
    padding: 2rem;
    box-sizing: border-box;
}

.right-section {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    box-sizing: border-box;
}
.branding {
    max-width: 400px;
    text-align: left;
    color: #fff;
}

.branding h1 {
    font-size: 2.5rem;
    margin-bottom: 1rem;
}

.branding p {
    font-size: 1.2rem;
}

.login-form {
    border: 1px solid #cfcfcf;
    border-radius: 2em;

    width: 100%;
    max-width: 550px;
    padding: 2rem;
    /* border-radius: 8px; */
    background: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
}

.login-form h2 {
    margin-bottom: 1.5rem;
    color: #333;
    text-align: center;
}

.login-form input {
    width: 100%;
    padding: 0.75rem;
    margin-bottom: 1rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
}

.login-form button {
    padding: 0.75rem;
    background-color: #0066cc;
    color: #fff;
    border: none;
    border-radius: 4px;
    font-weight: bold;
    cursor: pointer;
}

.login-form button:hover {
    background-color: #005bb5;
}

.domain-info {
    max-width: 90%;
    // margin-right: 120px;
}

.domain-info h1 {
    color: #196392;
    font-size: 33px;
    font-weight: 700;
    line-height: 1.3;
}

.domain-info .available {
    font-size: 18px;
    color: #0a0a0a;
    font-weight: 600;
}

.domain-info .v-btn {
    font-size: 24px;
    font-weight: bold;
    padding: 25px 40px;
    margin-left: 0px;
    margin-right: 0px;
}

.legal {
    font-size: 14px;
    line-height: 16px;
    color: #0a0a0a;
    max-width: 630px;
}

.strike-animate {
    position: relative;
    color: #999;
}

.strike-animate::after {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    height: 2px;
    background: red;
    width: 0;
    transform: translateY(-50%);
    animation: strikeLine 2s ease-in-out forwards;
}

/* Animate the "No" word */
.animate-no {
    display: inline-block;
    animation: bounceIn 2s ease-in-out infinite alternate;
    color: #007bff;
}

@keyframes strikeLine {
    from {
        width: 0;
    }

    to {
        width: 100%;
    }
}

@keyframes bounceIn {
    from {
        transform: scale(1);
        opacity: 0.8;
    }

    to {
        transform: scale(1.1);
        opacity: 1;
    }
}

/* FULL RESPONSIVE FOR MOBILE & TABLET */
@media (max-width: 1024px) {
    .login-container {
        flex-direction: column;
        padding: 1rem;
        background-position: top center;
    }

    .left-section {
        width: 100%;
        padding: 1rem;
        text-align: center;
    }

    .right-section {
        width: 100%;
        padding: 1rem;
    }

    .branding {
        max-width: 100%;
        color: #fff;
    }

    .branding h1 {
        font-size: 2rem;
    }

    .branding p {
        font-size: 1rem;
    }

    .domain-info {
        margin: 0 auto;
        max-width: 100%;
    }

    .domain-info h1 {
        font-size: 24px;
    }

    .domain-info .available {
        font-size: 16px;
    }

    .domain-info .v-btn {
        font-size: 18px;
        padding: 15px 25px;
    }

    .login-form {
        border: 1px solid #cfcfcf;
        border-radius: 2em;
        // max-width: 100%;
        padding: 1.5rem;
        margin: 0 auto;
        box-shadow: none;
        /* border-radius: 0; */
    }

    .login-form h2 {
        font-size: 1.5rem;
    }

    .password-toggle {
        right: 10px;
        font-size: 12px;
    }
}

h1,
p {
    margin-bottom: 0.5rem !important;
}

hr {
    margin: 0.5rem 0 !important;
}

.signup-wrapper {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    margin: 0;
}

.el-form-item {
    margin-bottom: 8px !important;
}

h1,
p,
hr {
    margin-top: 0 !important;
    margin-bottom: 0.5rem !important;
}

.password-input-wrapper {
    position: relative;
}

.password-toggle {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
    color: #409eff;
    cursor: pointer;
    user-select: none;
}

.name-fields {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

@media (min-width: 768px) {
    .name-fields {
        flex-direction: row;
    }

    .name-fields .el-form-item {
        flex: 1;
    }

    .name-fields .el-form-item:first-child {
        margin-right: 10px;
    }
}

.terms-wrap {
    display: inline-block;
    white-space: normal;
    word-break: break-word;
    max-width: 100%;
}

.d-flex {
    display: flex;
}

.justify-between {
    justify-content: space-between;
}

.align-center {
    align-items: center;
}

.flex-wrap {
    flex-wrap: wrap;
}

.mb-3 {
    margin-bottom: 1rem;
    /* adjust as needed */
}

.m-0 {
    margin: 0;
}

.register-heading {
    font-size: 1.25rem;
    font-weight: 600;
    color: #196392;
    padding-bottom: 0.5rem;
    margin: 0;
    display: inline-block;
}

.login-card {
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
}


/* Overlay animated hexagon pattern on top of gradient */
.login-card::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='92.4' viewBox='0 0 100 115.47'%3E%3Cpolygon fill='%23ffffff0D' points='50,0 100,28.87 100,86.6 50,115.47 0,86.6 0,28.87'/%3E%3C/svg%3E");
  background-repeat: repeat;
  background-size: 80px 92.4px;
  animation: floatPattern 30s linear infinite alternate;
  opacity: 0.3;
}

@keyframes floatPattern {
  0% { background-position: 0 0; }
  100% { background-position: 40px 40px; }
}


.wave-background {
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: -1;
}

.login-card {
  animation: fadeInUp 0.8s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

button {
  transition: all 0.3s ease;
}

button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
}

.landing-content{
    margin-top:27%;
    
        @media (max-width: 1024px) {

            margin-top: 5%;
        }
}


</style>

<style scoped>
.env-section {
  /* background: #f4f6f9; */
  padding: 40px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.content-wrapper {
  max-width: 800px;
  width: 100%;
  text-align: center;
}

.custom-header {
  font-size: 2.2rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 16px;
}

.custom-slogan {
  font-size: 1.2rem;
  font-weight: 400;
  color: #7f8c8d;
  margin-bottom: 12px;
}

.custom-content1 {
  font-size: 1rem;
  line-height: 1.6;
  color: #34495e;
  margin-bottom: 10px;
  text-align: justify;
}

.custom-content2 {
  font-size: 0.95rem;
  color: #555;
  line-height: 1.5;
  text-align: justify;
}

@media (max-width: 768px) {
  .hidden-sm-and-down {
    display: none !important;
  }

  .custom-header {
    font-size: 1.8rem;
  }

  .custom-slogan {
    font-size: 1rem;
  }

  .custom-content1,
  .custom-content2 {
    font-size: 0.95rem;
  }
}

.flip-text {
  display: inline-block;
  position: relative;
  width: 2.5em;
  height: 1.2em;
  perspective: 800px;
  vertical-align: middle;
}

.flip-text .front,
.flip-text .back {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  backface-visibility: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-style: normal;
  font-size: inherit;
  color: inherit;
  transition: transform 0.6s ease-in-out;
}

.front {
  transform: rotateY(0deg);
  animation: flipFront 4s infinite;
}

.back {
  transform: rotateY(-180deg);
  animation: flipBack 4s infinite;
}

@keyframes flipFront {
  0%, 45% {
    transform: rotateY(0deg);
  }
  55%, 100% {
    transform: rotateY(180deg);
  }
}

@keyframes flipBack {
  0%, 45% {
    transform: rotateY(-180deg);
  }
  55%, 100% {
    transform: rotateY(0deg);
  }
}

/* Strike Animation */
.strike-animate {
  position: relative;
  color: #999;
}

.strike-animate::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 0%;
  height: 2px;
  background-color: red;
  animation: strikeLine 2s forwards;
  transform: translateY(-50%);
}

@keyframes strikeLine {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}

</style>
